// Import model
import { FilterObjectAppointmentRequest } from '../models/FilterObjectAppointmentRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ObjectAppointmentCondition } from '../models/ObjectAppointmentCondition';
import { ObjectAppointmentFields } from '../models/ObjectAppointmentFields';
import { ObjectAppointmentIndexedFields } from '../models/ObjectAppointmentIndexedFields';

// Import dependency serializers (for complex types)
import { ObjectAppointmentConditionSerializer } from './ObjectAppointmentConditionSerializer';
import { ObjectAppointmentFieldsSerializer } from './ObjectAppointmentFieldsSerializer';
import { ObjectAppointmentIndexedFieldsSerializer } from './ObjectAppointmentIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterObjectAppointmentRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterObjectAppointmentRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterObjectAppointmentRequest instance
   */
  static deserialize(json: string): FilterObjectAppointmentRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterObjectAppointmentRequest instance
   */
  static fromObject(obj: any): FilterObjectAppointmentRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterObjectAppointmentRequest');
    }


    const instance: FilterObjectAppointmentRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as ObjectAppointmentIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as ObjectAppointmentFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        ObjectAppointmentConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterObjectAppointmentRequest instances
   */
  static deserializeArray(json: string): FilterObjectAppointmentRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterObjectAppointmentRequest instance to a JSON string
   */
  static serialize(instance: FilterObjectAppointmentRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterObjectAppointmentRequest instance to a plain object
   */
  static toObject(instance: FilterObjectAppointmentRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        ObjectAppointmentConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterObjectAppointmentRequest instances to a JSON string
   */
  static serializeArray(instances: FilterObjectAppointmentRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
